import styled, { css } from 'styled-components';
import { Stack } from 'components/Stack';
import CommonButton from 'components/Button';

export const defaultCardContainerStyle = css`
  border: 1px solid #00000061;
  border-radius: 4px;
`;

export const CardContainer = styled(Stack).attrs({
  direction: 'column',
  gap: 8,
  isFullWidth: true,
})<{
  isMobile: boolean;
  expanded: boolean;
  showArrow: boolean;
  isShowDropoffMap: boolean;
}>`
  ${defaultCardContainerStyle}
  padding: ${({ isMobile }) => (isMobile ? '16px 10px' : '16px')};
  cursor: ${({ showArrow }) => showArrow && 'pointer'};
  display: ${({ isShowDropoffMap }) => (isShowDropoffMap ? 'flex' : 'block')};
  flex-direction: ${({ isShowDropoffMap, isMobile }) =>
    isShowDropoffMap && !isMobile ? 'row' : 'column'};
`;

export const CardHeader = styled(Stack).attrs({
  direction: 'row',
  isFullWidth: true,
})`
  justify-content: space-between;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-size: 16px;
  line-height: 19px;
`;

export const CardPanel = styled(Stack).attrs({
  direction: 'column',
  gap: 8,
  isFullWidth: true,
})`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-size: 16px;
  line-height: 19px;
  padding: 4px 0;
`;

export const DropOffName = styled.span``;

export const Hyperlink = styled.a`
  width: fit-content;
  display: block;
  color: inherit;
  text-decoration: none;
`;

export const TitleContainer = styled(Stack).attrs({
  direction: 'column',
  gap: 8,
})`
  font-weight: 500;
  flex: 1 auto;
`;

export const IconContainer = styled.span``;

export const ButtonContainer = styled.div`
  height: 44px;
  width: 100%;
  position: relative;
`;

export const Button = styled(CommonButton)<{ isMobile: boolean }>`
  position: absolute;
  height: 100%;
  ${({ isMobile }) => isMobile && 'width: 100%;'}
  right: 0;
`;

export const DropOffInfoContainer = styled.div`
  flex: 1 1 auto;
  width: 100%;
`;

export const MapViewContainer = styled(Stack).attrs({
  align: 'center',
  justify: 'center',
})`
  flex: 0 0 60%;
  align-self: stretch;
`;
